import React from "react";

const Assets = () => {
  return <div>Team Assets</div>;
};

export default Assets;
